import React, { type ReactNode } from 'react';
import type Experiments from '@wix/wix-experiments';
import { ExperimentsProvider as WixExperimentsProvider } from '@wix/wix-experiments-react';

export interface IExperimentsWrapperProps {
  experiments: Experiments;
  children: ReactNode;
}

// NOTE: consider removing this provider and always use experiments from redux
export const ExperimentsProvider = (props: IExperimentsWrapperProps) => (
  <WixExperimentsProvider options={{ experiments: props.experiments.all() }}>{props.children}</WixExperimentsProvider>
);
